// Polyfill Blob.prototype.stream() via FileReader for environments lacking it.
if (!Blob.prototype.stream) {
  /** @returns a minimal ReadableStream-like object backed by FileReader */
  Blob.prototype.stream = function () {
    const blob = this;
    return {
      /** @returns a single-read reader yielding the whole blob */
      getReader() {
        return {
          /** @returns a promise resolving to the blob's bytes, done */
          read() {
            return new Promise<{ value: Uint8Array, done: boolean }>((resolve) => {
              const fileReader = new FileReader();
              fileReader.addEventListener('loadend', () => {
                resolve({
                  value: new Uint8Array(fileReader.result as ArrayBuffer),
                  done: true,
                });
              });
              fileReader.readAsArrayBuffer(blob);
            });
          },
        };
      },
    } as any;
  };
}